import { Preferences } from "@capacitor/preferences";
import { isNative } from "./platform.js";

const ACCESS = "auth.accessToken";
const REFRESH = "auth.refreshToken";

export async function saveTokens({ accessToken, refreshToken }) {
  if (!isNative()) return; // web: cookies httpOnly manejan la sesión
  if (accessToken) await Preferences.set({ key: ACCESS, value: accessToken });
  if (refreshToken) await Preferences.set({ key: REFRESH, value: refreshToken });
}

export async function loadTokens() {
  if (!isNative()) return { accessToken: null, refreshToken: null };
  const { value: accessToken } = await Preferences.get({ key: ACCESS });
  const { value: refreshToken } = await Preferences.get({ key: REFRESH });
  return { accessToken: accessToken ?? null, refreshToken: refreshToken ?? null };
}

export async function clearTokens() {
  if (!isNative()) return;
  await Preferences.remove({ key: ACCESS });
  await Preferences.remove({ key: REFRESH });
}

// Nota seguridad: `@capacitor/preferences` usa SharedPreferences/UserDefaults.
// Para endurecer (Keychain/Keystore cifrado) se puede sustituir por
// `capacitor-secure-storage-plugin` manteniendo esta misma interfaz. Decisión
// de hardening fuera del MVP; la interfaz (saveTokens/loadTokens/clearTokens)
// no cambia.
